import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Checkmark16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5606 3.49829L6.03211 13.0928L1.46967 8.53034L2.53033 7.46968L5.96788 10.9072L13.4394 2.50174L14.5606 3.49829Z'
      fill='currentColor'
    />
  </Svg>
);

Checkmark16.displayName = 'Checkmark16';
export default Checkmark16;
